import * as preact from "preact";

import * as deviceDetect from "deviceDetect";
import * as modalController from "modalController";
import readlangClient, { requestErrorMessage } from "readlangClient";
import Dialog from "views/Dialog";

type Fields = {
  oldPassword: string;
  password1: string;
  password2: string;
};

type State = Fields & {
  error: string | null;
};

export default class ChangePasswordDialog extends preact.Component<
  unknown,
  State
> {
  state: State = {
    oldPassword: "",
    password1: "",
    password2: "",
    error: null,
  };

  private updateField =
    (field: keyof Fields) =>
    (event: preact.JSX.TargetedEvent<HTMLInputElement>) => {
      this.setState({
        [field]: event.currentTarget.value,
        error: null,
      } as Pick<State, typeof field | "error">);
    };

  private confirmPasswordChange = async () => {
    const { oldPassword, password1, password2 } = this.state;

    if (password1.length < 5) {
      this.setState({ error: "Password must be at least 5 characters" });
      return;
    }

    if (password1 !== password2) {
      this.setState({ error: "Passwords don't match" });
      return;
    }

    try {
      await readlangClient.request("PUT", "/api/user", {
        oldPassword,
        newPassword: password1,
      });
    } catch (error) {
      this.setState({ error: requestErrorMessage(error) });
      return;
    }

    modalController.cancel();
    alert("Password changed successfully");
  };

  private handleConfirmKeyUp = (
    event: preact.JSX.TargetedKeyboardEvent<HTMLInputElement>
  ) => {
    if (event.which === 13) {
      this.confirmPasswordChange();
    }
  };

  render() {
    return (
      <Dialog
        heading="Change password"
        error={this.state.error}
        actions={
          <button
            class="clickable"
            id="user-confirmPassword"
            onClick={this.confirmPasswordChange}
          >
            Change Password
          </button>
        }
      >
        <div id="passwordForm">
          <table>
            <tbody>
              <tr>
                <td>Old Password</td>
                <td>
                  <label>
                    <input
                      autoFocus={!deviceDetect.isSmall()}
                      name="oldPassword"
                      onInput={this.updateField("oldPassword")}
                      type="password"
                      value={this.state.oldPassword}
                    />
                  </label>
                </td>
              </tr>
              <tr>
                <td>New Password</td>
                <td>
                  <label>
                    <input
                      name="password1"
                      onInput={this.updateField("password1")}
                      type="password"
                      value={this.state.password1}
                    />
                  </label>
                </td>
              </tr>
              <tr>
                <td>Confirm New Password</td>
                <td>
                  <label>
                    <input
                      name="password2"
                      onInput={this.updateField("password2")}
                      onKeyUp={this.handleConfirmKeyUp}
                      type="password"
                      value={this.state.password2}
                    />
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Dialog>
    );
  }
}
